import ParentPageBaseClass from "./common/ParentPageBaseClass";
import TicketSearchAreaClass from "./airplane/TicketSearchAreaClass";
import Util from "../libs/util/Util";
import PlaneTicket from "./plane_ticket/PlaneTicket";
import HotelSearchAreaClass from "./hotel/HotelSearchAreaClass";

export default class Manager extends ParentPageBaseClass {
    constructor(_target,_json) {
        super(_target);

        this.json = _json;

        //console.log("Manager",this.json);
    }

    async loadTopData(){
        this.isApiCall = true;

        Util.setAirplaneSearchParams();
        let airportData;
        if(this.json && this.json.airport) {
            airportData = this.json.airport;
        }

        await Util.yieldToMain();

        const tasks = [
            // "searchArea",
            "hotel",
            // "planeTicket"
        ];

        while (tasks.length > 0){
            const task = tasks.shift();

            let cl;

            switch (task){
                case "searchArea":
                    if(!this.json.airport) break;
                    cl = new TicketSearchAreaClass(this.target);
                    cl.onCreate();
                    cl.onSetData();
                    cl.onSetDefaultData(airportData);
                    break;
                case "hotel":
                    if(!this.json.hotel) break;
                    cl = new HotelSearchAreaClass(this.target);
                    cl.onCreate();
                    cl.onSetDefaultData(this.json.hotel);
                    break;
                case "planeTicket":
                    if(!this.json.ticket) break;
                    cl = new PlaneTicket(this.target);
                    cl.onCreate();
                    cl.onSetDefaultData(this.json.ticket);
                    break;
            }

            if(cl){
                cl.onLoad();
                cl.onResize(Util.getWindowSize());
                cl.onScroll(Util.getScrollY());

                this.things[task] = cl;
            }

            await Util.yieldToMain();
        }


    }
}